import type { Ref } from "vue";

import { ref, watchEffect } from "vue";

/**
 * Delays the loading state to reduce flicker
 */
function useDelayedLoading(loading: Readonly<Ref<boolean>>, delay = 200) {
  const delayedLoadingRef = ref(false);
  let timeout: ReturnType<typeof setTimeout> | null = null;

  watchEffect(() => {
    if (loading.value && !timeout) {
      timeout = setTimeout(() => {
        delayedLoadingRef.value = true;
      }, delay);
    } else {
      delayedLoadingRef.value = false;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }
  });

  return delayedLoadingRef as Readonly<Ref<boolean>>;
}

export { useDelayedLoading };
